import "./NotFoundPage.scss";
import "@mshop-ui/core-web-components/dist/ui-button";
import PropTypes from "prop-types";
import React from "react";
import Tracking from "../uidispatcherapi/Tracking";
import { FormattedMessage } from "react-intl";
import { withIntlRoot } from "../IntlRootMixin";

class NotFoundPageComponent extends React.Component {
	static contextTypes = {
		router: PropTypes.object.isRequired,
	};

	componentDidMount() {
		Tracking.trackPageImpression("notfound", "notfound");
	}

	redirect = () => {
		(this.context as any).router.push("/");
	};

	render() {
		return (
			<div className="no-page-found">
				<center>
					<img
						className="cable-guy-image"
						src="/ordercapture/uidispatcher/static/app/assets/images/error.png"
						alt="oops"
					/>
					<div className="page-text">
						<h1>
							<FormattedMessage id="PL_SORRY_PAGE_NON_EXISTEND" />
						</h1>
						<h5>
							<FormattedMessage id="PL_DESCRIPTION_PAGE_NON_EXISTEND" />
						</h5>
					</div>
					<ui-button>
						<button data-variant="action" onClick={this.redirect}>
							<FormattedMessage id="PL_RETURN_TO_HOMEPAGE" />
						</button>
					</ui-button>
				</center>
			</div>
		);
	}
}

export const NotFoundPage = withIntlRoot(NotFoundPageComponent);
